import { useEffect, useState } from 'react';
import { CancellationsGraphic } from './cancellationsGraphic'
import { CharbacksGraphic } from './chargebacksGraphic'
import { SpaceLoader } from '../../../../../loaders/spaceLoader';

import { Container, Content, Title } from './style'
import { BsInfoCircle } from 'react-icons/bs'

import { useAdministrativeContext } from '../../../../../../pages/administrativePanel/administrativePanelContext';
import { useDispatch } from 'react-redux';

export function CancellationsAndChargebacksGraphics() {
    const [forceLoading, setForceLoading] = useState(false)

    const { 
        startDate, 
        endDate, 
        listBusinessToFilter,
        listSalesChannelsId 
    } = useAdministrativeContext()
    const dispatch = useDispatch()

    useEffect(() => {
        let resizeThrottleTimeout;
        let skip = false;
        const resizeCb = () => {
          if (skip) {
            return;
          }
    
          setForceLoading(true);
          skip = true;
          resizeThrottleTimeout = setTimeout(() => {
            setForceLoading(false);
            skip = false;
          }, 100);
        };
        window.addEventListener('resize', resizeCb);
    
        return () => {
          setForceLoading(false)
          clearTimeout(resizeThrottleTimeout);
        }
      }, [setForceLoading]);


    return(
        <Container>
               
            <Content onClick={() => dispatch({
                   type: 'OPEN_CENTRALIZEDMODAL', 
                   title: "Vendas Canceladas", 
                   componentToShow: 'canceledOrders',
                   datasComponent: { 
                      endDate, 
                      startDate, 
                      business: listBusinessToFilter,
                      salesChannels: listSalesChannelsId,
                  } 
            })}>
                <BsInfoCircle />
                <Title>Cancelamentos</Title>
                {forceLoading ?
                    <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" /> 
                    :
                    <CancellationsGraphic />
                }
            </Content>

            <Content>
                <Title>Estornos</Title>
                {forceLoading ?
                    <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" /> 
                    :
                    <CharbacksGraphic />
                }
            </Content> 
        
        </Container>
    )
}